export default __webpack_public_path__ + "static/media/siteon.03b097ed.png";